// extracted by mini-css-extract-plugin
export default {"headerOnlyTitle":"aiAINp","title":"NBHD0S","button":"fy1g7m","buttonSmall":"qevMil"};